import { SITE_URL } from '../../configurations/api/url';
import { oauthCancelMessage, type OAuthCallbackFailure } from '../../utils/oauthCallbackMessages';

export function openMetaOAuthPopup(oauthUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
        // Mobile browsers often navigate the current tab when window.open is used —
        // that feels like a full page refresh. Prefer a real popup window features string.
        const popup = window.open(oauthUrl, 'meta-automation', 'popup=yes,width=600,height=700,noopener=no');
        if (!popup) {
            reject(
                new Error('Popup blocked. Allow popups for this site to connect Instagram without leaving the page.'),
            );
            return;
        }
        try {
            popup.focus();
        } catch {
            /* noop */
        }

        const appOrigin = window.location.origin;
        let configOrigin = appOrigin;
        try {
            configOrigin = new URL(SITE_URL).origin;
        } catch {
            /* noop */
        }

        const cleanup = () => {
            window.removeEventListener('message', handleMessage);
            clearInterval(timer);
        };

        const handleMessage = (event: MessageEvent) => {
            if (event.origin !== appOrigin && event.origin !== configOrigin) return;
            if (event.data?.type === 'SOCIAL_AUTH_SUCCESS' && event.data.code) {
                cleanup();
                try {
                    popup.close();
                } catch {
                    /* noop */
                }
                resolve(event.data.code as string);
            }
            if (event.data?.type === 'SOCIAL_AUTH_FAILED') {
                cleanup();
                try {
                    popup.close();
                } catch {
                    /* noop */
                }
                const failure = event.data as OAuthCallbackFailure;
                reject(
                    new Error(
                        failure.message ||
                            (failure.cancelled
                                ? oauthCancelMessage('meta')
                                : 'Instagram authorization was cancelled or failed.'),
                    ),
                );
            }
        };

        window.addEventListener('message', handleMessage);

        const timer = window.setInterval(() => {
            if (popup.closed) {
                cleanup();
                reject(new Error('Authorization window closed before completing.'));
            }
        }, 500);
    });
}
